import { CHILD_BENEFIT_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaApplicantAttributionBoth, schemaBigDecimal } from '../../utils/schema.utils';

export const Kind = z.object({
    alter: z.number().int().min(0).nullish().default(null),
    gehoertZuAntragsteller: schemaApplicantAttributionBoth,
    id: z.string().min(1),
    kindergeldFuer: z.nativeEnum(CHILD_BENEFIT_TYPES).nullish().default(null),
    kindergeldHoehe: z.number().nullish().default(259),
    // name: z.string().optional(), // TODO - fehlt im derzeitigen schema noch
    unterhaltseinnahmenMonatlich: schemaBigDecimal.nullish().default(null),
});

export type schemaKind = z.infer<typeof Kind>;

// INFO yup schema
//                     yup.object().shape({
//                         gehoertZuAntragsteller: yup
//                             .string()
//                             .oneOf(['ANTRAGSTELLER_1', 'ANTRAGSTELLER_2', 'BEIDE'])
//                             .required(),
//                         kindergeldFuer: yup
//                             .string()
//                             .oneOf(['ERSTES_ODER_ZWEITES_KIND', 'DRITTES_KIND', 'AB_VIERTEM_KIND', null])
//                             .optional()
//                             .nullable()
//                             .default(null),
//                         unterhaltseinnahmenMonatlich: yup.number().optional().nullable().default(null),
//                     }),
